import { SettlementPaymentDto } from '@/api/generated';

export type SettlementsToDo = {
  amount: number;
  payments: SettlementPaymentDto[];
};

export const settlementsToDo = (payments: SettlementPaymentDto[]): SettlementsToDo => {
  const unpaid = payments
    .filter(payment => !payment.paid)
    .sort((a, b) => a.createdAt.localeCompare(b.createdAt));

  return {
    amount: unpaid.reduce((sum, payment) => sum + payment.amount, 0),
    payments: unpaid,
  };
};
